import { Loading } from 'element-ui'
import {sesStorage, locStorage} from './storage'
export const getLoadingInstance = () => {
  let loadingInstance
  return ({
    show: () => {
      loadingInstance = Loading.service({
        lock: true,
        spinner: 'm-loading-spinner'
      })
    },
    close: () => setTimeout(() => loadingInstance && loadingInstance.close(), 300)
  })
}

export function loginOut() {
  sesStorage.clear()
  locStorage.clear()
}

export function downFileUrlDetail(url) {
  const host = 'https://eurmi.byd.com'
  let realHost = `https://eurmi.byd.com/oss`
  if (!url) {
    return ''
  }
  if (url.includes('http') || url.includes('https')) {
    if (!url.includes(realHost)) {
      url = url.replace(/^http(s)?:\/\/[^/]+\/(oss\/)?/, `${host}/`)
    }
  } else {
    url = `${host}${url}`
  }
  return url
}

export function downimgShow(url) {
  let realHost = `https://eurmi.byd.com/oss`
  url = `${realHost}${url}`
  return url
}
export const downloadFileBlob = (url, fileName) => {
  if (url) {
    const filePath = downFileUrlDetail(url)
    getFileBlob(filePath).then((res) => {
      downFile(res, fileName)
    })
  } else {
    Message({
      type: 'error',
      message: 'The file does not exist'
    })
  }
}

function getFileBlob(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', url, true)
    xhr.responseType = 'blob'
    xhr.onload = function() {
      if (xhr.status === 200) {
        resolve(xhr.response)
      } else {
        reject(new Error('error'))
      }
    }
    xhr.send()
  })
}

export function downFile(content, fileName) {
  const blob = new Blob([content])
  const elink = document.createElement('a')
  elink.download = fileName
  elink.style.display = 'none'
  elink.href = URL.createObjectURL(blob)
  document.body.appendChild(elink)
  elink.click()
  URL.revokeObjectURL(elink.href) // 释放URL 对象
  document.body.removeChild(elink)
}

export function _last(array) {
  let result = null
  if (Array.isArray(array) && array.length) {
    result = array[array.length - 1]
  }
  return result
}
